import store from './store';
import { Observable } from 'rxjs';

class SelectorSubscriptions {
  constructor() {
    this.nextId = 0;
    this.selectorsMap = new Map();

    store.subscribe(() => {
      const currentState = store.getState();
      for (let s of this.selectorsMap.values()) {
        const nextValue = s.selector(currentState);

        if (s.value !== nextValue) {
          s.value = nextValue;
          s.observer.next(nextValue);
        }
      }
    });
  }

  addSelector(selector) {
    const id = this.nextId++;
    return new Observable(observer => {
      const value = selector(store.getState());
      observer.next(value);
      this.selectorsMap.set(id, { selector, observer, value });

      return () => {
        this.selectorsMap.delete(id);
      };
    });
  }
}

const subscriptions = new SelectorSubscriptions();

const observe = selector => subscriptions.addSelector(selector);

export const getValue = selector  => selector(store.getState());

export default observe;